// extracted by mini-css-extract-plugin
export default {"tab__item":"tabMenu_tab__item__GCYSg","active":"tabMenu_active__HXs6k","off":"tabMenu_off__C6Jds"};